import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "text-muted-foreground pointer-events-none absolute top-0 right-2.5 text-xs leading-7.5" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "text-muted-foreground pointer-events-none absolute top-0 right-2.5 text-xs leading-7.5" }

import { InputRow, Combobox, Select } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { computed } from 'vue';
    import type { SelectOption } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { Alert } from '@/components/ui/alert';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeePensionForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const typeOptions = computed<SelectOption[]>(() => {
        return [
            { value: 'percentage', label: 'employee.pension.type_percentage' },
            { value: 'amount', label: 'employee.pension.type_option' },
        ];
    });

    const pensionCompanyOptions = computed<SelectOption[]>(() => {
        return [
            {
                value: t('employee.pension.pension_other'),
                label: t('employee.pension.pension_other'),
            },
            { value: 'AP', label: 'AP' },
            { value: 'AkademikerPension', label: 'AkademikerPension' },
            { value: 'Alm. Brand', label: 'Alm. Brand' },
            { value: 'Arkitekternes Pensionskasse', label: 'Arkitekternes Pensionskasse' },
            { value: 'Bankpension', label: 'Bankpension' },
            { value: 'Børne- og Ungdomspædagoger', label: 'Børne- og Ungdomspædagoger' },
            { value: 'Danica', label: 'Danica' },
            { value: 'Dansk Erhverv', label: 'Dansk Erhverv' },
            {
                value: 'Danske Civil - og Akademiingeniører',
                label: 'Danske Civil - og Akademiingeniører',
            },
            { value: 'Funktionærpension', label: 'Funktionærpension' },
            {
                value: 'Jordbrugsakademikere og Dyrlæger',
                label: 'Jordbrugsakademikere og Dyrlæger',
            },
            { value: 'Jurist og økonom', label: 'Jurist og økonom' },
            { value: 'Industriens Pension', label: 'Industriens Pension' },
            { value: 'Letpension', label: 'Letpension' },
            { value: 'Lægernes Pensionskasse', label: 'Lægernes Pensionskasse' },
            { value: 'Lærernes Pension', label: 'Lærernes Pension' },
            { value: 'Nordnet Bank', label: 'Nordnet Bank' },
            { value: 'Nordea Pension', label: 'Nordea Pension' },
            { value: 'P+(Djøf)', label: 'P+(Djøf)' },
            { value: 'P+(IDA)', label: 'P+(IDA)' },
            { value: 'PFA', label: 'PFA' },
            { value: 'PKA', label: 'PKA' },
            { value: 'PKA Plus Pension', label: 'PKA Plus Pension' },
            { value: 'PMF Pension', label: 'PMF Pension' },
            { value: 'Pen-Sam Liv', label: 'Pen-Sam Liv' },
            { value: 'PensionDanmark', label: 'PensionDanmark' },
            { value: 'SEB Pension', label: 'SEB Pension' },
            {
                value: 'Sampension (tidl. Grafisk Pension)',
                label: 'Sampension (tidl. Grafisk Pension)',
            },
            { value: 'Sampension (tidl. KP)', label: 'Sampension (tidl. KP)' },
            { value: 'Sampension (tidl. StK:Pension)', label: 'Sampension (tidl. StK:Pension)' },
            { value: 'Sampension vedr. tjenestemænd', label: 'Sampension vedr. tjenestemænd' },
            { value: 'Saxo Bank', label: 'Saxo Bank' },
            { value: 'Skandia Link', label: 'Skandia Link' },
            { value: 'Skandia Liv', label: 'Skandia Liv' },
            { value: 'Spar Lolland', label: 'Spar Lolland' },
            { value: 'Teknikum- Og Diplomingeniør', label: 'Teknikum- Og Diplomingeniør' },
            { value: 'Topdanmark', label: 'Topdanmark' },
            { value: 'Velliv', label: 'Velliv' },
        ];
    });

    const valueType = computed(() => {
        return props.form.companyPension.type === 'amount' ? 'kr.' : '%';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "type",
      label: "employee.pension.type",
      "error-key": "companyPension.type"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          id: "type",
          modelValue: _ctx.form.companyPension.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.companyPension.type) = $event)),
          options: typeOptions.value,
          placeholder: _unref(t)('employee.pension.type'),
          "show-remove-button": false,
          translate: ""
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    (_ctx.form.companyPension.type === 'amount')
      ? (_openBlock(), _createBlock(_unref(Alert), {
          key: 0,
          variant: "warning"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('employee.pension.amount_warning')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "employee_contribution",
      label: "employee.pension.employee_contribution",
      "error-key": "companyPension.employee_contribution"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Input), {
            id: "employee_contribution",
            modelValue: _ctx.form.companyPension.employee_contribution,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.companyPension.employee_contribution) = $event)),
            placeholder: _unref(t)('employee.pension.employee_contribution'),
            type: "number",
            step: "any"
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(valueType.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "company_contribution",
      label: "employee.pension.company_contribution",
      "error-key": "companyPension.company_contribution"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Input), {
            id: "company_contribution",
            modelValue: _ctx.form.companyPension.company_contribution,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.companyPension.company_contribution) = $event)),
            placeholder: _unref(t)('employee.pension.company_contribution'),
            type: "number",
            step: "any"
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(valueType.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "pension_company",
      label: "employee.pension.pension_company",
      "error-key": "companyPension.pension_company"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          id: "pension_company",
          modelValue: _ctx.form.companyPension.pension_company,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.companyPension.pension_company) = $event)),
          options: pensionCompanyOptions.value,
          placeholder: _unref(t)('employee.pension.select_pension_company'),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})